/**
 * Generated via @chakra-ui/cli
 * `npx @chakra-ui/cli snippet add toaster`
 */

'use client';

import {
    createToaster,
    Portal,
    Spinner,
    Stack,
    Toast,
    Toaster as ChakraToaster,
    ToasterProps as ChakraToasterProps,
    useSlotRecipe,
} from '@chakra-ui/react';

export const toaster = createToaster({
    placement: 'top',
    pauseOnPageIdle: true,
});

export const mapToaster = createToaster({
    placement: 'bottom',
});

export const Toaster = ({
    toasterInstance = toaster,
    variant,
    ...rest
}: Partial<ChakraToasterProps> & {
    toasterInstance?: ReturnType<typeof createToaster>;
    variant?: 'dark';
}) => {
    const recipe = useSlotRecipe({ key: 'toast' });
    const styles = recipe({ variant });

    return (
        <Portal>
            <ChakraToaster
                toaster={toasterInstance}
                maxW={'540px'}
                mx={
                    ['top', 'bottom'].includes(toasterInstance.attrs.placement) ? 'auto' : undefined
                }
                css={{
                    zIndex: 'toast !important',
                }}
                {...rest}
            >
                {toast => {
                    const { closable } = toast;
                    return (
                        <Toast.Root className={'nocowanie-root'} css={styles?.root}>
                            {toast.type === 'loading' ? (
                                <Spinner size="sm" color="secondary.solid" />
                            ) : (
                                <Toast.Indicator />
                            )}
                            <Stack gap="1" flex="1" maxWidth="100%">
                                {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
                                {toast.description && (
                                    <Toast.Description css={styles?.description}>
                                        {toast.description}
                                    </Toast.Description>
                                )}
                            </Stack>
                            {toast.action && (
                                <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
                            )}
                            {closable ? <Toast.CloseTrigger /> : null}
                        </Toast.Root>
                    );
                }}
            </ChakraToaster>
        </Portal>
    );
};
